<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单类型">
            <a-select :disabled="true" placeholder="请选择订单类型" v-decorator="[
          'orderType',
          {initialValue:data.orderType,rules: [{ required: true, message: '请选择订单类型' }]}]">
              <a-select-option value="0">标准订单</a-select-option>
              <a-select-option value="1">定制订单</a-select-option>
              <a-select-option value="2">促销订单</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分部审核">
          <a-radio-group name="branchAudit" v-decorator="[
          'branchAudit',
          {initialValue:data.branchAudit,rules: [{ required: true, message: '请选择是否分部审核' }]}]">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-row>
      <a-row>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总部审核">
          <a-radio-group name="headAudit" v-decorator="[
          'headAudit',
          {initialValue:data.headAudit,rules: [{ required: true, message: '请选择是否总部审核' }]}]">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-row>

      <a-row>
        <a-col class="form-row"></a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  orderType: undefined,
  headAudit: false,
  branchAudit: false
};
export default {
  name: "hp-manager-page-orderRule-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getdetailorderRule();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getdetailorderRule() {
      this.loading = true;
      let result = await api.GetOrderRule({ id: this.params.id });
      if (result) {
        this.data = result;
        this.data.orderType = this.data.orderType + "";
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        headAudit: value.headAudit,
        branchAudit: value.branchAudit,
        orderType: parseInt(value.orderType)
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.UpdateOrderRule(requestData);
        if (data) {
          if (this.params.id > 0) {
            this.$message.success("修改成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$emit("submit-success");
        }

        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Orders/OrderRule/Add.vue